import request from "../../utils/request";

export const userService = {
    //用户信息查询
    getUsers: (data) => {
        return request({
            url: "/user/list",
            method: "post",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            data: data,
        });
    },
    getUserListForStoreFeedbackBasic: (data) => {
        return request({
            url: "/user/userListForStoreFeedbackBasic",
            method: "post",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            data: data,
        });
    },
    FedbackReportTaskTransfer: (data) => {
        return request({
            url: "/myTask/FedbackReportTaskTransfer",
            method: "post",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            data: data,
        });
    },
    getUsersupplierList: (data) => {
        return request({
            url: "/user/usersupplierList",
            method: "post",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            data: data,
        });
    },
    //用户角色查询
    getUserRole: (userId) => {
        return request({
            url: "/user/role/" + userId,
            method: "post",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            data: {},
        });
    },
    //用户角色保存
    saveRole: (data, userId) => {
        return request({
            url: "/user/saveRole/" + userId,
            method: "post",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            data: data,
        });
    },
    savePostRole: (data, userJobId) => {
        return request({
            url: "/userjob/userJobRoles/" + userJobId,
            method: "post",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            data: data,
        });
    },
    // 岗位管理权限保存
    savePostUserInfo: (id, data) => {
        return request({
            url: `/userjob/userJobDataScope/${id}`,
            method: "post",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            data: data,
        });
    },
    //用户信息保存
    saveUserInfo: (data) => {
        return request({
            url: "/user/edit",
            method: "post",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            data: data,
        });
    },
    //用户信息保存
    syncUser: (data) => {
        return request({
            url: "/user/syscUserFromPortal",
            method: "get",
        });
    },
    syncPostUser: (data) => {
        return request({
            url: "/user/syncUsers",
            method: "post",
        });
    },
    changeLoginAgreementFlag: (data) => {
        return request({
            url: "/user/changeLoginAgreementFlag",
            method: "post",
            data: data,
        });
    },
    getLeaderByUserId: (userId, leaderType) => {
        return request({
            url: `/user/getLeaderByUserId?userId=${userId}&leaderType=${leaderType}`,
            method: "get",
        });
    },
    setLeaderByUserId: (data) => {
        return request({
            url: "/user/setLeaderByUserId",
            method: "post",
            data: data,
        });
    },
    getSSoLoginInfo: (target) => {
        return request({
            url: `/login/loginUrl?target=${target}`,
            method: "get",
        });
    },
    getPost: (data) => {
        return request({
            url: "/userjob/list",
            method: "post",
            data: data,
        });
    },
    savePostInfo: (data) => {
        return request({
            url: "/userjob/save",
            method: "post",
            data: data,
        });
    },
    deletePostInfo: (data) => {
        return request({
            url: "/userjob/delete",
            method: "post",
            data: data,
        });
    },
    getPostInfo: (userId) => {
        return request({
            url: `/userjob/detail/${userId}`,
            method: "get",
        });
    },
};